import {useState} from 'react'
import logo from './assets/logo.png'
import './App.css'
import './assets/style.css'
import {CustomerFilter} from "./customer/CustomerFilter.tsx";
import type {CustomerData} from "./core/CustomerData.ts";
import {PluginFilter} from "./project/PluginFilter.tsx";
import type {PluginData} from "./core/PluginData.ts";
import {Tag} from "./project/Tag.tsx";
import {MailAddress} from "./mailAddress/MailAddress.tsx";

function App() {
    const [customer, setCustomer] = useState<CustomerData>();
    const [mailAddress, setMailAddress] = useState('');
    const [mailAddressState, setMailAddressState] = useState<'Negative' | 'None'>('None');
    const [plugin, setPlugin] = useState<PluginData>()
    const [requestedPluginId, setRequestedPluginId] = useState<string>();

    return <div className="sc_app">
        <div>
            <a href="https://vite.dev" target="_blank">
                <img src={logo} className="logo" alt="Survey consulting logo"/>
            </a>
        </div>
        <h1>Publish a plugin</h1>
        <p className="read-the-docs">
            Input a customer name for retrieving plugins
        </p>
        <MailAddress
            onMailAddressChange={mailAddress => setMailAddress(mailAddress)}
            onMailAddressStateChange={state => setMailAddressState(state)}
        />
        <CustomerFilter
            disabled={mailAddressState === 'Negative' ? true : undefined}
            onSelect={customer => {
                console.log('customer selected', customer);
                setCustomer(customer);
                setPlugin(undefined);
            }}/>

        {customer && mailAddressState !== 'Negative' ? <PluginFilter
                customer={customer} onSelect={(plugin) => {
                setPlugin(plugin);
            }}/>
            : <></>
        }

        {customer && mailAddressState !== 'Negative' && plugin ? plugin.tags.map(tag => <Tag
                mailAddress={mailAddress}
                onPluginRequested={id => setRequestedPluginId(id)}
                plugin={plugin}
                requestedPluginId={requestedPluginId}
                tag={tag}
            />)
            : <></>}
    </div>
}

export default App;
